import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFade, Autoplay, Pagination } from 'swiper';
import { Link } from 'react-router-dom';

SwiperCore.use([EffectFade, Autoplay, Pagination]);

const SlidingHero = () => {
  return (
    <div className="SlidingHero mb-5">
      <Swiper
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
        speed={1000}
      >
        <SwiperSlide>
          <img src={`${process.env.PUBLIC_URL}/images/hero/hero--imlek-2023.jpg`} alt="Banner Year End" className="w-100 rounded" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
};

export default SlidingHero;
